import { CircularProgress, styled } from '@material-ui/core';
import { palette } from '../../settings/themes/colors';

export const Loading = styled(CircularProgress)({
  color: palette.captudataBlue
});
